module.exports = __webpack_public_path__ + "img/user.f8e20c2b.png";